import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import UploadImageIcon from "@/assets/images/icons/image.svg";
import {
  computed,
  getCurrentInstance,
  reactive,
  watch,
} from "@vue/composition-api";

export default function useImageUpload(props) {
  const vm = getCurrentInstance().proxy;

  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal();

  const uploadImage = reactive({ file: null, url: props.imageUrl || null });

  const renderImageUrl = computed(() => {
    let img = uploadImage.url || UploadImageIcon;
    img = img.replaceAll(" ", "%20");

    return {
      "background-image": `url(${img})`,
    };
  });

  const handleUploadChange = (e) => {
    const filesOBJ = event.target.files[0];

    try {
      const size = (filesOBJ.size / 1024 / 1024).toFixed(2);

      if (filesOBJ.name.length > 0) {
        var isValidExtension = false;
        var fileExtension = null;

        const _validFileExtensions = props.acceptFile;

        for (var i = 0; i < _validFileExtensions.length; i++) {
          var curExtension = _validFileExtensions[i];
          fileExtension = filesOBJ.name
            .substr(
              filesOBJ.name.length - curExtension.length,
              curExtension.length
            )
            .toLowerCase();

          if (fileExtension == curExtension.toLowerCase()) {
            isValidExtension = true;
            if (size <= 2) {
              const newImageUrl = URL.createObjectURL(filesOBJ);
              uploadImage.file = filesOBJ;
              uploadImage.url = newImageUrl;
              vm.$emit('onUpload', uploadImage)
            } else {
              openErrorModal(
                "ไฟล์รูปภาพมีขนาดเกิน 2 MB",
                "<span>ขนาดไฟล์ที่อัปโหลด </span> " +
                  size +
                  "<span> MB</span>" +
                  "<div>กรุณาอัปโหลดไฟล์ใหม่อีกครั้ง</div>",
                "ปิด"
              );
            }
            break;
          }
        }

        if (!isValidExtension) {
          openErrorModal(
            "อัปโหลดไฟล์รูปภาพไม่ถูกต้อง",
            "<div>กรุณาอัปโหลดใหม่อีกครั้ง</div>" +
              "<div class='text-bold'>นามสกุลไฟล์ที่รองรับ " +
              _validFileExtensions.join(", ") +
              "</div>",
            "ปิด"
          );
          return (uploadImage.file = null);
        }
      }
    } catch (err) {}
  };

  const handleDelete = () => {
    uploadImage.file = null;
    uploadImage.url = null;
    vm.$refs.refInputEl.value = null;
    vm.$emit("onUpload", uploadImage);
  };

  const onUpload = () => {
    vm.$refs.refInputEl.click();
  };

  watch(
    () => props.imageUrl,
    () => {
      uploadImage.url = props.imageUrl;
    },
    { deep: true }
  );

  return {
    renderImageUrl,
    uploadImage,
    handleUploadChange,
    onUpload,
    handleDelete,
  };
}
